import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ClearTheChaosWithJoeGio from "./sections/ClearTheChaosWithJoeGio";
import WhatWeHaulAway from "./sections/WhatWeHaulAway";
import TheHaulItAllProcess from "./sections/TheHaulItAllProcess";
import ScheduleYourHaul from "./sections/ScheduleYourHaul";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ClearTheChaosWithJoeGio />
      <WhatWeHaulAway />
      <TheHaulItAllProcess />
      <ScheduleYourHaul />
      <Footer />
    </div>;
}